var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.hasStatus ? ['status-badge', `status-badge--${_vm.resolvedVariant}`] : 'status-badge-empty',attrs:{"data-status":_vm.hasStatus ? _vm.normalizedStatus : null}},[(_vm.hasStatus)?_c('span',{staticClass:"status-badge__label"},[_vm._v(_vm._s(_vm.displayLabel))]):_c('span',[_vm._v("—")])])
}
var staticRenderFns = []

export { render, staticRenderFns }